export default __webpack_public_path__ + "images/2D.9c5ed8d.png";